import * as tslib_1 from "tslib";
import { personaCardBehavior, } from 'owa-persona/lib/components/PersonaCardBehavior';
import { observer } from 'mobx-react';
import React from 'react';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { PersonaSize } from 'office-ui-fabric-react/lib';
var styles = require('../SearchBoxPillWell.scss');
var PeopleSegmentPart = /** @class */ (function (_super) {
    tslib_1.__extends(PeopleSegmentPart, _super);
    function PeopleSegmentPart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PeopleSegmentPart.prototype.render = function () {
        var _a = this.props, emailAddress = _a.emailAddress, name = _a.name;
        return (React.createElement("div", { className: styles.personaPill, onMouseEnter: this.props.onPersonaCardBehaviorMouseEnter, onMouseLeave: this.props.onPersonaCardBehaviorMouseLeave },
            React.createElement(PersonaControl, tslib_1.__assign({}, { name: name, emailAddress: emailAddress }, { size: PersonaSize.extraExtraSmall })),
            React.createElement("div", { className: styles.segmentName, title: name }, name)));
    };
    PeopleSegmentPart = tslib_1.__decorate([
        personaCardBehavior,
        observer
    ], PeopleSegmentPart);
    return PeopleSegmentPart;
}(React.Component));
export default PeopleSegmentPart;
//# sourceMappingURL=PeopleSegmentPart.js.map